import { FC, useMemo } from "react";
import orderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper from "./order-optimizer-raily-details-hidden-details-center-tables-orders-order-table.helper";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderTableRow from "../../types/order-optimizer-raily-details-hidden-details-center-tables-orders-order-table-row";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import TableComponent, {
  TableProps,
} from "../../../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../../../context/app.context";
import OrderOptimizerDetailsTableDotComponent from "../../../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import {
  OrderOptimizerRailyDetailsItemDriver,
  OrderOptimizerRailyDetailsItemStepsOrdersPoints,
} from "../../../../common/types/order-optimizer-raily-details-item";
import orderOptimizerRailyDetailsHelper from "../../../../order-optimizer-raily-details.helper";

type OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableProps =
  Pick<TableProps, "isError" | "isLoading"> & {
    driver: OrderOptimizerRailyDetailsItemDriver | null;
    allStepPoints: OrderOptimizerRailyDetailsItemStepsOrdersPoints[];
    stepPoints: OrderOptimizerRailyDetailsItemStepsOrdersPoints[];
    stepOffset: number;
  };

const OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const createTableRow = (
    detailsStepsOrdersPointsItem: OrderOptimizerRailyDetailsItemStepsOrdersPoints,
    index: number,
  ): OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderTableRow => {
    const timeLabel = orderOptimizerRailyDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time,
    );
    const timeTitle = orderOptimizerRailyDetailsHelper.getTimeLabel(
      detailsStepsOrdersPointsItem.time,
    );

    const distanceLabel = orderOptimizerRailyDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance,
    );
    const distanceTitle = orderOptimizerRailyDetailsHelper.getDistanceLabel(
      detailsStepsOrdersPointsItem.distance,
    );

    const haltingTimeLabel = orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime,
    );
    const haltingTimeTitle = orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(
      detailsStepsOrdersPointsItem.haltingTime,
    );

    const dotColor = "#d9d9d9";
    const stepPointIndex = props.stepOffset + index;

    const isFirstPoint = stepPointIndex === 0;
    const isLastStepPoint = index === props.stepPoints.length - 1;

    const googleMapsPoints: OrderOptimizerRailyDetailsItemStepsOrdersPoints[] =
      [];

    if (!isFirstPoint) {
      googleMapsPoints.push(props.allStepPoints[stepPointIndex - 1]);
    }
    googleMapsPoints.push(props.allStepPoints[stepPointIndex]);

    return {
      id: uuidService.generate(),
      value: {
        humanId: (
          <div className="order_optimizer_raily_details_hidden_details_center_tables_order__humanId">
            <span style={{ width: "8px" }} title={String(stepPointIndex + 1)}>
              {stepPointIndex + 1}
            </span>
            <OrderOptimizerDetailsTableDotComponent color={dotColor} />
          </div>
        ),
        address: (
          <div title={detailsStepsOrdersPointsItem.displayName}>
            {detailsStepsOrdersPointsItem.displayName}
          </div>
        ),
        time: (
          <div
            className={isLastStepPoint ? "last_driver_time" : ""}
            title={timeTitle}
          >
            {timeLabel}
          </div>
        ),
        haltingTime: (
          <div
            title={haltingTimeTitle!}
            className={
              detailsStepsOrdersPointsItem.haltingTime < 0 ? "time_delayed" : ""
            }
          >
            {haltingTimeLabel}
          </div>
        ),
        distance: <div title={distanceTitle}>{distanceLabel}</div>,
        actions: (
          <TableLinkButtonComponent
            icon={faMap}
            openInNewTab
            to={orderOptimizerRailyDetailsHelper.getGoogleMapsUrl(
              googleMapsPoints,
              props.driver?.startLat,
              props.driver?.startLon,
              isFirstPoint,
              false,
            )}
            type="primary"
          />
        ),
      },
    };
  };

  const rows: OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrderTableRow[] =
    useMemo(() => {
      return props.stepPoints.map(createTableRow);
    }, [props.stepPoints, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersOrdTableComponent;
